import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { environment } from "src/environments/environment";
import { Constants } from "projects/shared/src/app/shared/constants/constants";

@Injectable({ providedIn: 'root' })
export class MasterTrainerService {
	constructor(private apiService: ApiService) { }
	getMasterTrainerBasedonLocation(
		state: number,
		district: number,
		originationCategory: string,
		country: string,
		jobRoles,
		pageNo = 1,
		itemsPerPage = Constants.RECORDSPERPAGE,
		type = "masterTrainer",
		name = "",
		userName = ""
	) {
		const masterTrainerUrl = `${environment.userServiceUrl}/api/user/v1/trainer`;
		console.log(masterTrainerUrl);
		return this.apiService.get(masterTrainerUrl, {
			itemsPerPage: itemsPerPage,
			pageNo: pageNo,
			jobRoles: jobRoles.toString(),
			type: type,
			state: state,
			district: district,
			name: name,
			userName: userName,
			originationCategory: originationCategory,
			countryCode: country !== "IN" ? country : "",
		});
	}
	getMasterTrainers(
		pageno: number = 0,
		limit: number = Constants.RECORDSPERPAGE
	) {
		const masterTrainerUrl = `${environment.ToTServiceURL}/api/tot/master-trainer?pageNo=${pageno}&&perPage=${limit}`;
		return this.apiService.get(masterTrainerUrl);
	}
	getMasterTrainer(id) {
		const masterTrainerUrl = `${environment.ToTServiceURL}/api/tot/master-trainer/${id}`;
		return this.apiService.get(masterTrainerUrl);
	}

	getMasterTrainerForSCC(
		role,
		jobRoles,
		pageno: number = 0,
		limit: number = Constants.RECORDSPERPAGE
	) {
		const masterTrainerUrl = `${environment.userServiceUrl}/api/user/v1/trainer`;
		console.log(masterTrainerUrl);
		return this.apiService.get(masterTrainerUrl, {
			itemsPerPage: limit,
			pageNo: pageno,
			jobRoles: jobRoles.toString(),
			type: role,
		});
	}

	assigBatchToMasterTrainer(reqObj) {
		// http://localhost:3003/v1/batch/{batchId}/jobRoles/{qpCode}/masterTrainerDetails
		const Url = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/${reqObj.batchId}/jobRoles/masterTrainerDetails`;
		console.log(Url);
		return this.apiService.patch(Url, {
			userName: reqObj.userName,
			name: reqObj.name,
			qpCode: reqObj.qpCode,
			email: reqObj.email,
			version: reqObj.version,
			isPlatformQP: reqObj.isPlatformQP,
			isPwdQP: reqObj.isPwdQP
		});
	}
}
